module.exports = "<div class='cart-widget'>\n  <span class=\"fa fa-shopping-cart\" aria-hidden=\"true\"></span> ${{total|number:'1.2-2'}}\n  <input type=\"button\" class=\"btn btn-primary\" value=\"View Cart\" [routerLink]=\"['/admin', 'shop', 'checkout']\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/cart-widget/cart-widget.component.html
// module id = ./src/app/admin/cart-widget/cart-widget.component.html
// module chunks = main